<template>
  <div class="error-page">
    <div class="card ev-fluid-card-wide">
      <div class="error-page-bottom-padding">
        <div class="superdude-logo">
          <img
            class="evpay-superdude-img"
            src="/images/evpay_assets/evpay_superhero_med.png"
            alt="evpay-superdude"
          />
        </div>
        <h3 class="col-12 pt-3 text-center">
          We're sorry, something went wrong.
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
